import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { tableColor, getStringByTheme, showElementByTheme } from '../utils/utils';

import { ELEMENT } from '../constants/constants';

// import { ReactComponent as ReloadLogo } from '../images/reload.svg';
import { ReactComponent as MobileTicketIcon } from '../images/mobile-ticket.svg';
import { ReactComponent as CallLogo } from '../images/call-icon.svg';
import { ReactComponent as CounterLogo } from '../images/counter-icon.svg';

import '../styles/tag-sequence.scss';

export const TagSequence = ({ tagSequence, showTicketLabel = true, showQueueServiceTempUnavailable = false, latestTag }) => {

  const lang = useSelector((state) => state.system.lang);
  const theme = useSelector((state) => state.system.theme);

  const [color, setColor] = useState('A');

  useEffect(() => {
    if (tagSequence && tagSequence.tableType) {
      setColor(tableColor(tagSequence.tableType));
    }
  }, [tagSequence])

  return (
    <>
      {
        tagSequence &&
        <div key={tagSequence.tagLabel + tagSequence.updateTimestamp} className={`tag-sequence text-${color} background-dark-${color} ${(latestTag === tagSequence.tagLabel) ? 'blink' : ''}`}>
          {
            tagSequence.tableTypeLabel &&
            <div className="table-type-label">{tagSequence.tableTypeLabel}</div>
          }
          <div className="ticket-number">
            <div className="text">
              {
                showElementByTheme(ELEMENT.TAG_SEQUENCE_CALL_LOGO, theme) &&
                <CallLogo className={`sound-icon logo-${color}`} />
              }
              <div>{tagSequence.tagLabel}</div>
              {
                tagSequence.counterName &&
                <>
                  <CounterLogo className={`counter-icon logo-${color}`} />
                  <div className={`counter-name bg-${color} ${(tagSequence.counterName.length > 1) ? 'long' : ''}`}>{tagSequence.counterName.toUpperCase()}</div>
                </>
              }
            </div>
            {/* <ReloadLogo className={`reload-icon logo-${color}`} /> */}
          </div>
          <div className={`zig-zag zig-zag-${color}`}></div>
          <div className="time">
            {
              !showQueueServiceTempUnavailable &&
              <span>{'@ ' + ((tagSequence.updateTimestamp) ? moment(tagSequence.updateTimestamp).locale('en').format('HH:mm') : '----')}</span>
            }
          </div>
          {
            showTicketLabel && tagSequence.ticketLabel &&
            <div className="ticket-sequence-wrapper">
              {
                tagSequence.mobileQueueAvailable &&
                <MobileTicketIcon className={`image ${color}`} />
              }
              <div className="label">{getStringByTheme('ticketSequence', lang, theme)}</div>
              <div className="ticket-sequence">
                <div className="zig-zag"></div>
                <div className={`ticket text-${color}`}>{tagSequence.ticketLabel}</div>
                <div className={`zig-zag zig-zag-bottom`}></div>
              </div>
            </div>
          }
          {
            tagSequence.quota != null && !isNaN(Number(tagSequence.quota)) && Number(tagSequence.quota) >= 0 &&
            <div className="quota">{'(' + getStringByTheme('dailyQuota', lang, theme) + ' ' + tagSequence.quota + ')'}</div>
          }
        </div>
      }
    </>
  )
}